import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const PendingBlogs = () => {
  const [pendingBlogs, setPendingBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPendingBlogs();
  }, []);

  const fetchPendingBlogs = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://blog-backend-ivfv.onrender.com/pending");
      if (!response.ok) {
        throw new Error("Failed to fetch pending blogs");
      }
      const data = await response.json();
      setPendingBlogs(data);
    } catch (error) {
      console.error(error);
      toast.error("Error fetching pending blogs");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      const response = await fetch(
        `https://blog-backend-ivfv.onrender.com/blogs/approve/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to approve blog");
      }
      toast.success("Blog approved successfully!");
      fetchPendingBlogs();
    } catch (error) {
      console.error(error);
      toast.error("Failed to approve blog");
    }
  };

  const handleReject = async (id) => {
    try {
      const response = await fetch(`https://blog-backend-ivfv.onrender.com/blogs/reject/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to reject blog");
      }
      toast.success("Blog rejected successfully!");
      fetchPendingBlogs();
    } catch (error) {
      console.error(error);
      toast.error("Failed to reject blog");
    }
  };

  const handleViewFullBlog = async (id) => {
    try {
      setLoading(true);
      const response = await fetch(`https://blog-backend-ivfv.onrender.com/blogsbyId/${id}`);
      if (!response.ok) {
        throw new Error("Failed to fetch blog details");
      }
      const data = await response.json();
      setSelectedBlog(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch blog details");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSelectedBlog(null);
  };

  return (
    <div className="container mt-5">
      <ToastContainer />
      <h2 className="text-center mb-4 text-primary fw-bold">Pending Blogs</h2>

      {loading && <div className="text-center">Loading...</div>}

      {!loading && pendingBlogs.length === 0 && (
        <div className="alert alert-info text-center">No pending blogs found.</div>
      )}

      {!loading && pendingBlogs.length > 0 && (
        <div className="list-group">
          {pendingBlogs.map((blog, index) => (
            <div key={blog._id} className="list-group-item border rounded shadow-sm mb-3">
              <div className="d-flex justify-content-between">
                <div>
                  <span className="badge bg-secondary me-2">#{index + 1}</span>
                  <strong className="text-dark h5">Blog Name : {blog.title}</strong>
                  
                </div>
                <div className="d-flex align-items-center">
                  <OverlayTrigger overlay={<Tooltip>View Full Blog</Tooltip>}>
                    <button
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={() => handleViewFullBlog(blog._id)}
                    >
                      View
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip>Approve Blog</Tooltip>}>
                    <button
                      className="btn btn-outline-success btn-sm me-2"
                      onClick={() => handleApprove(blog._id)}
                    >
                      Approve
                    </button>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip>Reject Blog</Tooltip>}>
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleReject(blog._id)}
                    >
                      Reject
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal for selected blog */}
      {selectedBlog && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h5 className="modal-title">{selectedBlog.title}</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
              </div>
              <div className="modal-body">
                <p><strong>Summary:</strong> {selectedBlog.summary}</p>
                <p><strong>Category:</strong> <span className="badge bg-info text-dark">{selectedBlog.category}</span></p>
                {selectedBlog.image && (
                  <img
                    src={`data:image/jpeg;base64,${selectedBlog.image}`}
                    alt="Blog"
                    className="img-fluid mb-3 rounded"
                  />
                )}
                <div dangerouslySetInnerHTML={{ __html: selectedBlog.content }} />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingBlogs;
